import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const SearchAndFilters = ({ searchQuery, setSearchQuery, filters, setFilters }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4 elevation-sm space-y-4">
      {/* Search Bar */}
      <div className="relative">
        <Icon
          name="Search"
          size={18}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
        />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e?.target?.value)}
          placeholder="Search by company name, contact, or email..."
          className="w-full pl-10 pr-4 py-2.5 bg-background border border-border rounded-md text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 transition-smooth"
        />
      </div>
      {/* Filters */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <Select
          value={filters?.subscriptionStatus}
          onChange={(e) => setFilters({ ...filters, subscriptionStatus: e?.target?.value })}
          className="w-full"
        >
          <option value="all">All Status</option>
          <option value="active">Active</option>
          <option value="trial">Trial</option>
          <option value="suspended">Suspended</option>
          <option value="cancelled">Cancelled</option>
        </Select>

        <Select
          value={filters?.planType}
          onChange={(e) => setFilters({ ...filters, planType: e?.target?.value })}
          className="w-full"
        >
          <option value="all">All Plans</option>
          <option value="Free">Free</option>
          <option value="Growth">Growth</option>
          <option value="Scale">Scale</option>
          <option value="Enterprise">Enterprise</option>
        </Select>

        <Select
          value={filters?.activityLevel}
          onChange={(e) => setFilters({ ...filters, activityLevel: e?.target?.value })}
          className="w-full"
        >
          <option value="all">All Activity</option>
          <option value="high">High Activity</option>
          <option value="medium">Medium Activity</option>
          <option value="low">Low Activity</option>
        </Select>

        <Select
          value={filters?.registrationDate}
          onChange={(e) => setFilters({ ...filters, registrationDate: e?.target?.value })}
          className="w-full"
        >
          <option value="all">All Time</option>
          <option value="last7days">Last 7 Days</option>
          <option value="last30days">Last 30 Days</option>
          <option value="last90days">Last 90 Days</option>
          <option value="lastyear">Last Year</option>
        </Select>
      </div>
      {/* Clear Filters */}
      {(searchQuery || filters?.subscriptionStatus !== 'all' || filters?.planType !== 'all' || filters?.activityLevel !== 'all' || filters?.registrationDate !== 'all') && (
        <button
          onClick={() => {
            setSearchQuery('');
            setFilters({
              subscriptionStatus: 'all',
              planType: 'all',
              activityLevel: 'all',
              registrationDate: 'all'
            });
          }}
          className="flex items-center gap-2 px-3 py-1.5 text-sm text-muted-foreground hover:text-foreground transition-smooth"
        >
          <Icon name="X" size={14} />
          Clear all filters
        </button>
      )}
    </div>
  );
};

export default SearchAndFilters;